module.exports = {"id":"210372","name":"Rachid Ghezzal","rating":"75","photo":"./data/images/photos/2/210372.png","club":{"name":"AS Monaco","logo":"./data/images/clubs/ASMonaco.png"},"positions":["AD","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RachidGhezzal0.json
// module id = 3493
// module chunks = 0